import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';

import App from './App';
import reportWebVitals from './reportWebVitals';
import clerkAppearance from './themes/clerkAppearance';
import { config } from './config/runtimeConfig';

const publishableKey = config.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (typeof publishableKey !== 'string' || publishableKey.length === 0) {
  throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY in web/.env');
}

const clerkPublishableKey: string = publishableKey;

function ClerkProviderWithRouter({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  return (
    <ClerkProvider
      publishableKey={clerkPublishableKey}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      appearance={clerkAppearance}
    >
      {children}
    </ClerkProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <ClerkProviderWithRouter>
      <App />
    </ClerkProviderWithRouter>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
